export const abTestFlagJson = {
    shopType2: 'A',
    pddSingleLink: 'A',
    immersive: 'A',
    sqbCompareCountDown: 'A',
    homeCpsMarket: 'A',
    newbieGuide: 'A',
    appSqbQuery: 'A',
    rollHotWord4675: 'A',
    hotWord: 'A',
    shopType: 'A',
    brandRoot: 'A',
    privilegeCategory: 'A',
};

export default abTestFlagJson;
